/**
 * Provides functions to manipulate user passwords.
 * @class
 * @param {Restangular} Restangular
 */
function ResetPasswordService(Restangular) {
    this._api = Restangular.one('password');
    this._myAccountApi = Restangular.one('MyAccount/Password');
}

/**
 * Tries to send the forgot password email if the user is valid.
 * @param {string} email - The user provided email
 * @returns {Promise}
 */
ResetPasswordService.prototype.forgotPassword = function (email) {
    return this._api.post('ForgotPassword', { email });
};

/**
 * Validates the provided password reminder token.
 * @param {string} token
 * @returns {Promise}
 */
ResetPasswordService.prototype.validatePasswordReminderToken = function (token) {
    return this._api.post('ValidateToken', { ReminderToken: token });
};

/**
 * Resets the user's password with a reminder token.
 * @param {string} newPassword
 * @param {string} newPasswordConfirmation
 * @param {string} reminderToken
 * @returns {Promise}
 */
ResetPasswordService.prototype.resetPassword = function (newPassword, newPasswordConfirmation, reminderToken) {
    return this._api.post('ResetPassword', { NewPassword: newPassword, NewPasswordConfirmation: newPasswordConfirmation, ReminderToken: reminderToken });
};

/**
 * Changes the user's password.
 * @param {string} password
 * @returns {Promise}
 */
ResetPasswordService.prototype.changePassword = function (password) {
    return this._myAccountApi.doPOST({ CurrentPassword: password.CurrentPassword, NewPassword: password.NewPassword });
};

module.exports = ResetPasswordService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/resetpassword/reset-password-service.js
 **/